import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.VersionPage.title',
    defaultMessage: 'Version Page',
  },
})
